const ColorSync = {
  mounted() {
    this.picker = this.el.querySelector("[data-color-picker]")
    this.text = this.el.querySelector("[data-color-text]")
    this.syncSwatch = () => {
      if (this.picker && this.picker.value) {
        this.el.style.setProperty("--seiva-color-picker-color", this.picker.value)
      }
    }

    this.syncSwatch()

    // Color picker -> text input
    this.pickerInputHandler = () => {
      this.text.value = this.picker.value
      this.syncSwatch()
      this.text.dispatchEvent(new Event("input", { bubbles: true }))
    }

    // Text input -> color picker (on valid hex)
    this.textInputHandler = () => {
      let val = this.text.value.trim()
      if (!val.startsWith("#")) val = "#" + val
      if (/^#[0-9A-Fa-f]{6}$/.test(val)) {
        this.picker.value = val
        this.syncSwatch()
      }
    }

    if (this.picker) this.picker.addEventListener("input", this.pickerInputHandler)
    if (this.text) this.text.addEventListener("input", this.textInputHandler)
  },

  destroyed() {
    if (this.picker && this.pickerInputHandler) {
      this.picker.removeEventListener("input", this.pickerInputHandler)
    }
    if (this.text && this.textInputHandler) {
      this.text.removeEventListener("input", this.textInputHandler)
    }
  }
}

export default ColorSync
